import React, {useEffect} from 'react';
import {isSpecialSmallDeviceDetect} from '../../util/isSpecialSmallDeviceDetect';
import DesktopWardDashboard from './desktopWardDashboard';
import makeStyles from '@mui/styles/makeStyles';
import {loadWardList} from '../../store/reducers/ward';
import {useDispatch} from 'react-redux';

export const useWardDashboardStyles = makeStyles((theme) => ({
    root: {
        overflowX: 'hidden',
        overflowY: 'hidden',
        height: '100vh',
    },
    rowDiv: {
        display: 'flex',
        flexWrap: 'nowrap',
        flexDirection: 'row',
        alignItems: 'center',
        '&.marginLeft': {
            marginLeft: 5,
        },
    },
    right: {
        marginLeft: 'auto',
        marginRight: 15,
    },
    agyleMenu: {
        paddingTop: 2,
        margin: '0 5px',
    },
    settingButton: {
        borderRadius: 8,
        minWidth: 38,
        backgroundColor: theme.palette.background.paper,
        margin: '0 5px',
    },
    menuLabel: {},
    backDrop: {
        // backdropFilter: theme.palette.blur,
    },
    cards: {
        padding: 10,
        maxHeight: '93%',
    },
    counter: {
        background: theme.palette.admissionForm.toggleBackground,
        borderRadius: 7,
        padding: 5,
        marginLeft: 8,
        minWidth: 29,
        height: 29,
        display: 'inline-flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    mapLabel: {
        display: 'flex',
        alignItems: 'center',
    },
}));

const WardDashboard = () => {
    const dispatch = useDispatch();
    const classes = useWardDashboardStyles();

    // Mobile dashboard check
    const isSmallDevice = isSpecialSmallDeviceDetect();

    useEffect(() => {
        dispatch(loadWardList());
    }, []);

    // TODO: Implement the mobile dashboard
    return (
        <div className={classes.root}>
            {/*{isSmallDevice && <MobileWardDashboard/>}*/}
            {/*{!isSmallDevice && <DesktopWardDashboard/>}*/}
            <DesktopWardDashboard/>
        </div>
    );
};

export default WardDashboard;